import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import GoogleConfigService from '@/services/SettingsServices/GoogleConfigService';
import { extractError } from '@/helpers/extractApiError';

const model = {
    data: null,
    submitting: false,
    errors: null,
    successOnCreate: '',
    loading: false,
};

export const getGoogleConfig = createAsyncThunk(
    'google/getGoogleConfig',
    async (_, { rejectWithValue }) => {
        try {
            const response = await GoogleConfigService.getGoogleConfig();
            return response.data;
        } catch (error) {
            return rejectWithValue(extractError(error));
        }
    },
);

export const addGoogleConfig = createAsyncThunk(
    'google/addGoogleConfig',
    async (data, { rejectWithValue }) => {
        try {
            const response = await GoogleConfigService.addGoogleConfig(data);
            return response.data;
        } catch (error) {
            return rejectWithValue(extractError(error));
        }
    },
);

const googleSlice = createSlice({
    name: 'google',
    initialState: model,
    reducers: {
        resetGoogleStateOnError: (state) => {
            state.errors = null;
        },
        resetGoogleStateOnSuccess: (state) => {
            state.successOnCreate = '';
        },
    },
    extraReducers: (builder) => {
        // get google config
        builder.addCase(getGoogleConfig.pending, (state) => {
            state.loading = true;
        }).addCase(getGoogleConfig.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        }).addCase(getGoogleConfig.rejected, (state) => {
            state.loading = false;
        });

        // add google config
        builder.addCase(addGoogleConfig.pending, (state) => {
            state.submitting = true;
        }).addCase(addGoogleConfig.fulfilled, (state) => {
            state.submitting = false;
            state.successOnCreate = 'Google Configuration added successfully!';
        }).addCase(addGoogleConfig.rejected, (state, action) => {
            state.submitting = false;
            state.errors = action.payload;
        });
    },
});

export const {
    resetGoogleStateOnError,
    resetGoogleStateOnSuccess,
} = googleSlice.actions;

export default googleSlice.reducer;
